const listaErrores = (err: any) => {
  if (!err?.response?.data?.error_data) return;
  const lista = document.getElementById("lista-errores");
  const fragment = document.createDocumentFragment();
  err?.response?.data?.error_data.forEach((item: any) => {
    const p = document.createElement("p");
    p.textContent = item;
    const referenceNode = fragment.firstChild;
    fragment.insertBefore(p, referenceNode);
  });
  lista?.appendChild(fragment);
  return lista;
};

const formatBodySaveReporte = (data: any) => {
  const body = {
    numero: data.no,
    anio: data.anio,
    cveMateria: data.cveMateria.cveMateria,
    cveTipoNumero: data.cveTipoNumero.cveTipoNumero,
    cveadscripcion: data.cveJuzgado.IdJuzgado,
    cveInstancia: data.cveInstancia.cveInstancia,
    observaciones: data.observaciones,
    cveMotivo: data.cveMotivo.cveTipoMotivoReporte,
  };

  return body;
};
const toInputUppercase = (e: any) => {
  e.target.value = ("" + e.target.value).toUpperCase();
};
const onlyNumbers = (value: any) => {
  // Elimina todos los caracteres que no sean números utilizando una expresión regular.
  return value.replace(/[^0-9]/g, "");
};
const verifyDataToCertKeyList = (data: any) => {
  const expectDataCerKey = [
    {
      cert: {
        certBase64: "",
        name: "",
      },
      key: {
        keyBase64: "",
        name: "",
      },
    },
  ];

  if (!data.length) return;

  if (expectDataCerKey.length !== data.length) {
    return false;
  }

  expectDataCerKey.sort();
  data.sort();

  for (let i = 0; i < expectDataCerKey.length; i++) {
    if (expectDataCerKey[i] !== data[i]) {
      return false;
    }
  }

  return true;
};

const converFileToBase64 = (file: any): Promise<string> => {
  return new Promise((resolve) => {
    let baseURL: string;
    let reader = new FileReader();

    reader.readAsDataURL(file);
    reader.onload = () => {
      baseURL = reader.result as string;
      const startIndex = baseURL.indexOf(",") + 1;
      resolve(baseURL.substring(startIndex));
    };
  });
};

export const createIframeWithBase64 = (base64String: string, type: string) => {
  // Decodificar la cadena Base64 en datos binarios
  const byteCharacters = atob(base64String);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);

  // Crear un Blob a partir de los datos binarios
  const blob = new Blob([byteArray], { type: type }); // Asegúrate de especificar el tipo de imagen correcto

  const blobUrl = URL.createObjectURL(blob);

  const iframe = document.createElement("iframe");
  iframe.style.display = "none";
  iframe.src = blobUrl;
  document.body.appendChild(iframe);

  iframe.onload = function () {
    // Puedes realizar acciones adicionales aquí si es necesario
    // Por ejemplo, imprimir el contenido del iframe
    if (iframe.contentWindow) {
      iframe.contentWindow.print();
    }
    // Liberar el Blob URL cuando ya no se necesite
    URL.revokeObjectURL(blobUrl);
  };
};
const base64SVGToImgURL = (base64SVG: string) => {
  const decodedSVG = atob(String(base64SVG));
  const blob = new Blob([decodedSVG], { type: "image/svg+xml" });
  return URL.createObjectURL(blob);
};
const createIframe = (blobUrl: any) => {
  const iframe = document?.createElement("iframe");
  iframe.style.display = "none";
  iframe.src = blobUrl;
  document.body.appendChild(iframe);
  iframe.onload = function () {
    iframe?.contentWindow?.print();
  };
};
const base64ToImgURL = (base64Data: string, contentType: string) => {
  const decodedData = atob(String(base64Data));
  const uint8Array = new Uint8Array(decodedData.length);

  for (let i = 0; i < decodedData.length; i++) {
    uint8Array[i] = decodedData.charCodeAt(i);
  }

  const blob = new Blob([uint8Array], { type: contentType });
  return URL.createObjectURL(blob);
};
const pdfToBlob = (binaryPdf: any) => {
  const byteArray = new Uint8Array(binaryPdf);
  for (let i = 0; i < binaryPdf.length; i++) {
    byteArray[i] = binaryPdf.charCodeAt(i) & 0xff;
  }

  return new Blob([byteArray.buffer], { type: "application/pdf" });
};
const generateUniqueID = () => {
  const currentTimestamp = new Date().getTime(); // Obtiene la marca de tiempo actual en milisegundos
  const uniqueID = currentTimestamp + Math.floor(Math.random() * 1000); // Agrega un número aleatorio para mayor unicidad
  return uniqueID;
};

const mergeArrays = (array1: any, array2: any) => {
  // Verificar si los arrays tienen la misma longitud
  if (array1.length !== array2.length) {
    throw new Error("Los arrays no tienen la misma longitud");
  }
  // Nueva matriz para almacenar los objetos fusionados
  let mergedArray = [];
  // Iterar sobre los arrays
  for (let i = 0; i < array1.length; i++) {
    // Fusionar los objetos en la misma posición de los arrays
    let mergedObject = Object.assign({}, array1[i], array2[i]);
    mergedArray.push(mergedObject);
  }

  return mergedArray;
};
export {
  converFileToBase64,
  formatBodySaveReporte,
  listaErrores,
  onlyNumbers,
  toInputUppercase,
  verifyDataToCertKeyList,
  base64SVGToImgURL,
  createIframe,
  pdfToBlob,
  base64ToImgURL,
  generateUniqueID,
  mergeArrays,
};
